import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const Navbar = ({ setSelectedMenu, selectedMenu }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [orgCode, setOrgCode] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUserInfo = localStorage.getItem("user");
        if (storedUserInfo) {
            const parsedUserInfo = JSON.parse(storedUserInfo);
            setUserInfo(parsedUserInfo);
            setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const formatDateTime = () => {
        const now = new Date();
        const options = {
            weekday: 'long',
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return now.toLocaleDateString('en-US', options);
    };

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
        setIsOpen(false); // Close mobile menu after selection
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark position-fixed top-0 start-0 w-100 z-index-1 bg-primary" style={{ zIndex: 1050 }}>
                <div className="container-fluid">
                    <span className="navbar-brand mb-0 h1 cursor-pointer" onClick={() => navigate('/dashboard')}>{userInfo?.organizationInfo?.name}</span>
                    <span className="text-white d-none d-lg-block">
                        {formatDateTime()}
                    </span>
                    <button
                        className="navbar-toggler border-0"
                        type="button"
                        onClick={() => setIsOpen(true)}
                    >
                        <i className="ri-menu-3-fill"></i>
                    </button>

                    <div className="collapse navbar-collapse justify-content-end">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a 
                                    className={`nav-link  ${selectedMenu === 'ordertoken' ? 'active fw-bold' : ''}`}

                                    onClick={() => handleMenuClick('ordertoken')}
                                >
                                    Kitchen Order
                                </a>
                            </li>
                            <li className="nav-item">
                                <a 
                                    className={`nav-link  ${selectedMenu === 'bartoken' ? 'active fw-bold' : ''}`}

                                    onClick={() => handleMenuClick('bartoken')}
                                >
                                    Bar Order
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div 
                className={`position-fixed top-0 start-0 h-100 bg-white shadow-lg transition-transform ${isOpen ? 'translate-0' : '-translate-100'}`}
                style={{
                    width: '250px',
                    transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
                    transition: 'transform 0.3s ease-in-out',
                    zIndex: 1050
                }}
                ref={menuRef}
            >
                <div className="d-flex justify-content-between align-items-center p-3 bg-primary">
                    <span className="text-white h5 mb-0">Menu</span>
                    <button
                        className="btn btn-link text-white p-0"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <div className="p-3 border-bottom">
                    <small className="text-muted">{formatDateTime()}</small>
                </div>

                <ul className="nav flex-column p-3">
                    <li className="nav-item">
                        <a 
                            className={`nav-link text-dark py-2 ${selectedMenu === 'ordertoken' ? 'active' : ''}`}
                            href="#"
                            onClick={() => handleMenuClick('ordertoken')}
                        >
                            Kitchen Order
                        </a>
                    </li>
                    <li className="nav-item">
                        <a 
                            className={`nav-link text-dark py-2 ${selectedMenu === 'bartoken' ? 'active' : ''}`}
                            href="#"
                            onClick={() => handleMenuClick('bartoken')}
                        >
                            Bar Order
                        </a>
                    </li>
                </ul>
            </div>

            {isOpen && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark"
                    style={{
                        opacity: '0.5',
                        zIndex: 1040
                    }}
                    onClick={() => setIsOpen(false)}
                />
            )}
        </>
    );
};